import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import withSessionCheck from '../../../withSessionCheck';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import EventIcon from '@mui/icons-material/Event';
import ListAltIcon from '@mui/icons-material/ListAlt';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import FitbitIcon from '@mui/icons-material/Fitbit';
import GamepadIcon from '@mui/icons-material/Gamepad';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { Rectangle } from 'recharts';

function PatientIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state        
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout, isAppointmentNeeded } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageEdit, setErrorMessageEdit] = useState("");

    // FOR Create new customer
    const [Name, setName] = useState('');
    const [AddressLine1, setAddressLine1] = useState('');
    const [AddressLine2, setAddressLine2] = useState('');
    const [ContactNumber1, setContactNumber1] = useState('');
    const [ContactNumber2, setContactNumber2] = useState('');
    const [Location, setLocation] = useState('');
    const [PostalCode, setPostalCode] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        fetchPaymentModes();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    //search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [isFocused, setIsFocused] = useState(false);
    const fetchtableData = async () => {
        setLoading(true);
        fetchData('PatientApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
                console.log(response);
            })
            .catch((error) => {
                console.error('Error fetching Patient Details:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('PatientApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);

                setConfirmDialogOpen(false);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('PatientApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const addGroupRecord = async (e) => {
        e.preventDefault();
        setIsLoading(true); // show loader

        if (!Name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }

        // ✅ Check duplicate by comparing case-insensitive
        const isDuplicate = data.some(
            (item) => item.Name.trim().toLowerCase() === Name.trim().toLowerCase()
        );

        if (isDuplicate) {
            setErrorMessage("This Patient Name already exists!");
            setIsLoading(false);
            return;
        }

        const Patient = {
            CompanyId: companyId,
            Name,
            AddressLine1,
            AddressLine2,
            ContactNumber1,
            ContactNumber2,
            Location,
            PostalCode,
            IsActive: true,
            CreatedBy: userId,
            CreatedDate: new Date(),
        };

        postData('PatientApi', Patient, token)
            .then((response) => {
                console.log('Patient Created success:', response);
                setSuccessMessage("Patient Created successfully!");
                setErrorMessage("");
                setName("");
                setAddressLine1("");
                setAddressLine2("");
                setContactNumber1("");
                setContactNumber2("");
                setLocation("");
                setPostalCode("");

                setIsModalGrpOpen(false);
                window.location.reload();

                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Customer Create error:', error);
            })
            .finally(() => {
                setIsLoading(false); // hide loader
            });
    };

    //EDIT
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const openDetailModal = async (Id) => {
        try {
            const response = await fetchData('PatientApi', `/MasterDetails/${Id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    // master Group model
    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const toggleModalGroup = () => {
        setIsModalGrpOpen(!isModalGrpOpen);
    };

    const toggleModalGrp2 = () => {
        setIsDetailModalOpen(false);
        // setSelectedBalanceSheetType(null);
        setErrorMessageEdit('');
    };

    //Appointment List - All Appointments Modal
    const [isModalGrpOpenAppointment, setIsModalGrpOpenAppointment] = useState(false);
    const [appointmentsList, setAppointmentsList] = useState([]);
    const [appointmentDateFilter, setAppointmentDateFilter] = useState('');
    const [appointmentDoctorFilter, setAppointmentDoctorFilter] = useState('');
    const [isLoadingAppointments, setIsLoadingAppointments] = useState(false);

    //Patient History Modal - Single Patient
    const [isPatientHistoryModalOpen, setIsPatientHistoryModalOpen] = useState(false);
    const [patientHistoryList, setPatientHistoryList] = useState([]);
    const [selectedPatientForList, setSelectedPatientForList] = useState(null);
    const [isLoadingPatientHistory, setIsLoadingPatientHistory] = useState(false);

    // Format date to dd/mm/yyyy
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    // Filter appointments based on date and doctor
    const getFilteredAppointments = () => {
        return appointmentsList.filter(apt => {
            // Date filter - compare only the date part (YYYY-MM-DD)
            let dateMatch = true;
            if (appointmentDateFilter && apt.AppointmentDate) {
                const aptDate = new Date(apt.AppointmentDate);
                const filterDate = new Date(appointmentDateFilter);
                dateMatch = aptDate.toDateString() === filterDate.toDateString();
            }

            const doctorMatch = !appointmentDoctorFilter || apt.DoctorName === appointmentDoctorFilter;
            return dateMatch && doctorMatch;
        });
    };

    const toggleModalGroupAppointments = async () => {
        if (!isModalGrpOpenAppointment) {
            // Opening modal - fetch all appointments
            setSelectedPatientForList(null); // null means show all
            setIsLoadingAppointments(true);
            setIsModalGrpOpenAppointment(true);

            try {
                const response = await fetchData('AppointmentApi', `/${companyId}`, token);
                if (response.responseCode === '1111') {
                    // Sort all appointments by date (newest first) and doctor
                    const sortedAppointments = response.response_data.sort((a, b) => {
                        const dateCompare = new Date(b.AppointmentDate) - new Date(a.AppointmentDate);
                        if (dateCompare !== 0) return dateCompare;
                        return (a.DoctorName || '').localeCompare(b.DoctorName || '');
                    });
                    setAppointmentsList(sortedAppointments);
                } else {
                    setAppointmentsList([]);
                }
            } catch (error) {
                console.error('Error fetching appointments:', error);
                setAppointmentsList([]);
            } finally {
                setIsLoadingAppointments(false);
            }
        } else {
            // Closing modal
            setIsModalGrpOpenAppointment(false);
        }
    };

    // Open patient history modal for specific patient
    const openAppointmentListModal = async (patientId, patientName, patientMRD) => {
        setSelectedPatientForList({ id: patientId, name: patientName, mrd: patientMRD });
        setIsLoadingPatientHistory(true);
        setIsPatientHistoryModalOpen(true);

        try {
            const response = await fetchData('AppointmentApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                // Filter appointments for this patient and sort by date (newest first)
                const patientAppointments = response.response_data
                    .filter(apt => apt.PatientId === patientId)
                    .sort((a, b) => new Date(b.AppointmentDate) - new Date(a.AppointmentDate));
                setPatientHistoryList(patientAppointments);
            } else {
                setPatientHistoryList([]);
            }
        } catch (error) {
            console.error('Error fetching patient appointments:', error);
            setPatientHistoryList([]);
        } finally {
            setIsLoadingPatientHistory(false);
        }
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});

    // Appointment Modal States
    const [isAppointmentModalOpen, setIsAppointmentModalOpen] = useState(false);
    const [appointmentFormData, setAppointmentFormData] = useState({});
    const [doctors, setDoctors] = useState([]);
    const [isAppointmentLoading, setIsAppointmentLoading] = useState(false);

    // Get current date and time
    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getCurrentTime = () => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    // Fetch doctors for appointment
    const fetchDoctors = async () => {
        try {
            const response = await fetchData('DoctorApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                let availableDoctors = response.response_data;

                // If appointment feature is enabled, check doctor availability from Doctor Diary
                if (isAppointmentNeeded) {
                    try {
                        const diaryResponse = await fetchData('DoctorDiaryApi', `/${companyId}`, token);
                        if (diaryResponse.responseCode === '1111') {
                            const doctorDiaries = diaryResponse.response_data;

                            // Filter doctors who have diary entries (available doctors)
                            const doctorsWithDiary = new Set(doctorDiaries.map(diary => diary.DoctorId));
                            availableDoctors = availableDoctors.filter(doctor => doctorsWithDiary.has(doctor.Id));
                        }
                    } catch (diaryError) {
                        console.error('Error fetching doctor diary:', diaryError);
                        // If diary fetch fails, show all doctors as fallback
                    }
                }

                setDoctors(availableDoctors);
            }
        } catch (error) {
            console.error('Error fetching doctors:', error);
        }
    };

    // Open appointment modal with patient details
    const openAppointmentModal = async (patientId) => {
        try {
            const response = await fetchData('PatientApi', `/MasterDetails/${patientId}`, token);
            if (response.responseCode === '1111') {
                const patient = response.response_data;
                
                // Find Cash payment mode ID
                const cashMode = paymentModes.find(mode => mode.Name.toLowerCase() === 'cash');
                const defaultPaymentModeId = cashMode ? cashMode.Id : '';
                
                setAppointmentFormData({
                    patientId: patient.Id,
                    patientName: patient.Name,
                    patientMRD: patient.MRDNo,
                    patientPhone: patient.ContactNumber1,
                    consultationamount: patient.ConsultationAmount,
                    appointmentDate: getCurrentDate(),
                    appointmentTime: getCurrentTime(),
                    paymentModeId: defaultPaymentModeId,
                    IsPaymentCollected: true
                });
                await fetchDoctors();
                setIsAppointmentModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching patient details:', error);
        }
    };

    const handleAppointmentChange = (name, value) => {
        setAppointmentFormData((prev) => ({ ...prev, [name]: value }));
    };


    const [paymentModes, setPaymentModes] = useState([]);
    const fetchPaymentModes = async () => {
        try {
            const response = await fetchData('DoctorEntryApi', `/paymentmodes/${companyId}`, token);
            if (response.responseCode === '1111') {
                setPaymentModes(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching payment modes:', error);
        }
    };

    const handleAppointmentSubmit = async (e) => {
        e.preventDefault();
        setIsAppointmentLoading(true);
        try {
            const payload = {
                ...appointmentFormData,
                CompanyId: companyId,
                Amount: Number(appointmentFormData.consultationamount),
                BillAmount: Number(appointmentFormData.consultationamount),
                ReceivedAmount: appointmentFormData.IsPaymentCollected ? Number(appointmentFormData.consultationamount) : 0,
                PaymentTypeId: parseInt(appointmentFormData.paymentModeId) || null,
                IsPaymentCollected: appointmentFormData.IsPaymentCollected || false,
                createdBy: userId,
                createdDate: new Date(),
            };
            postData('AppointmentApi', payload, token)
                .then((response) => {
                    console.log('Appointment Created success:', response);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
            alert('Appointment created successfully!');
            setIsAppointmentModalOpen(false);
            setAppointmentFormData({});
        } catch (error) {
            console.error('Error creating appointment:', error);
            alert('Failed to create appointment');
        } finally {
            setIsAppointmentLoading(false);
        }
    };

    const updateRecord = async (event) => {
        event.preventDefault();
        setIsUpdateLoading(true); // start loading

        if (!updatedData.Name) {
            setErrorMessageEdit('Name is required !');
            setIsUpdateLoading(false);
            return;
        }

        try {
            // Include BalanceSheetHeadId from the selected dropdown
            const dataToUpdate = {
                ...updatedData,
                //  BalanceSheetHeadId: selectedBalanceSheetType?.value || updatedData.BalanceSheetHeadId
            };

            await updateData('PatientApi', `${updatedData.Id}`, dataToUpdate, token);

            setUpdateData({
                CompanyId: companyId,
                Name: '',
            });
            //setSelectedBalanceSheetType(null);

            window.location.reload();
            setIsDetailModalOpen(false);
            fetchtableData();
        } catch (error) {
            console.error('Error updating record:', error);
        } finally {
            setIsUpdateLoading(false); // stop loading
        }
    };

    return (
        <div className="container mt-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div className='mb-2 flex justify-between' style={{ marginTop: '-20px' }}>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', textTransform: 'uppercase' }}>Patient</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        backdropFilter: 'blur(4px)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <style>{`
                            .loader {
                                transform: rotateZ(45deg);
                                perspective: 1000px;
                                border-radius: 50%;
                                width: 48px;
                                height: 48px;
                                color: #fff;
                            }
                            .loader:before,
                            .loader:after {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: inherit;
                                height: inherit;
                                border-radius: 50%;
                                transform: rotateX(70deg);
                                animation: 1s spin linear infinite;
                            }
                            .loader:after {
                                color: #FF3D00;
                                transform: rotateY(70deg);
                                animation-delay: .4s;
                            }
                            @keyframes spin {
                                0%, 100% {
                                    box-shadow: .2em 0px 0 0px currentcolor;
                                }
                                12% {
                                    box-shadow: .2em .2em 0 0 currentcolor;
                                }
                                25% {
                                    box-shadow: 0 .2em 0 0px currentcolor;
                                }
                                37% {
                                    box-shadow: -.2em .2em 0 0 currentcolor;
                                }
                                50% {
                                    box-shadow: -.2em 0 0 0 currentcolor;
                                }
                                62% {
                                    box-shadow: -.2em -.2em 0 0 currentcolor;
                                }
                                75% {
                                    box-shadow: 0px -.2em 0 0 currentcolor;
                                }
                                87% {
                                    box-shadow: .2em -.2em 0 0 currentcolor;
                                }
                            }
                        `}</style>
                        <div className="loader"></div>
                        <span style={{ color: 'white', marginTop: '30px', fontSize: '16px', fontWeight: '500', letterSpacing: '0.5px' }}>
                            Loading...
                        </span>
                    </div>
                )}

                <div style={{ marginLeft: '-30px', marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>

                <Tooltip
                    title="Appointments" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: 'White',
                                color: 'black',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '11px', textTransform: 'uppercase', marginTop: '-2px', borderRadius: '25px' }}
                        onClick={toggleModalGroupAppointments}
                        className="linkcolor"
                    >
                        Appointments
                    </Button>
                </Tooltip>

                <Tooltip
                    title="Patient Registration" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: 'White',
                                color: 'black',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '11px', textTransform: 'uppercase', marginTop: '-2px', borderRadius: '25px' }}
                        onClick={toggleModalGroup}
                        className="linkcolor"
                    >
                        New Patient
                    </Button>
                </Tooltip>
            </div>

            {isModalGrpOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                    <div
                        className="bg-white w-full overflow-hidden"
                        style={{
                            maxWidth: '900px',
                            maxHeight: '70vh',
                            borderRadius: '16px',
                            boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                            animation: 'zoomIn 0.3s ease-out'
                        }}
                    >
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            // background: 'linear-gradient(135deg, #041815ff 0%, #045157ff 100%)',
                            padding: '16px 24px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                            height: '55px',
                        }}>
                            <div style={{ height: '20px' }}>
                                <h6 style={{
                                    color: 'white',
                                    fontSize: '15px',
                                    fontWeight: '700',
                                    margin: 0,
                                    letterSpacing: '-0.3px',
                                    marginTop: '-10px',
                                }}>
                                    New Patient
                                </h6>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    fontSize: '13px',
                                    margin: '2px 0 0 0'
                                }}>
                                    Add a new patient to your system
                                </p>
                            </div>
                            <button
                                onClick={toggleModalGroup}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.2)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '36px',
                                    height: '36px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    color: 'white',
                                    fontSize: '22px',
                                    fontWeight: '300'
                                }}
                                onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                                onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                            >
                                ×
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div className="overflow-y-auto" style={{ maxHeight: 'calc(85vh - 150px)', padding: '16px 20px' }}>

                            {errorMessage && (
                                <div style={{
                                    background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
                                    border: '1px solid #fca5a5',
                                    borderRadius: '12px',
                                    padding: '16px',
                                    marginBottom: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px'
                                }}>
                                    <span style={{ fontSize: '20px' }}>⚠️</span>
                                    <p style={{ color: '#991b1b', fontSize: '14px', margin: 0, fontWeight: '500' }}>{errorMessage}</p>
                                </div>
                            )}

                            <form onSubmit={addGroupRecord}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    {/* Section 1: Basic Information */}
                                    <div>

                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                            <div className="md:col-span-3">
                                                <label style={{
                                                    display: 'block',
                                                    color: '#374151',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    marginBottom: '6px'
                                                }}>
                                                    Name <span style={{ color: '#ef4444' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={Name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '7px 10px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '32px'
                                                    }}
                                                    placeholder="Enter Patient name"
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Section 2: Address Information */}
                                    <div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            {[
                                                { label: 'Address Line 1', value: AddressLine1, setter: setAddressLine1, placeholder: 'Street address' },
                                                { label: 'Address Line 2', value: AddressLine2, setter: setAddressLine2, placeholder: 'Apartment, suite, etc.' }
                                            ].map((field, index) => (
                                                <div key={index}>
                                                    <label style={{
                                                        display: 'block',
                                                        color: '#374151',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '6px'
                                                    }}>{field.label}</label>
                                                    <input
                                                        type="text"
                                                        value={field.value}
                                                        onChange={(e) => field.setter(e.target.value)}
                                                        style={{
                                                            width: '100%',
                                                            padding: '9px 12px',
                                                            border: '2px solid #e5e7eb',
                                                            borderRadius: '10px',
                                                            fontSize: '13px',
                                                            transition: 'all 0.2s ease',
                                                            outline: 'none',
                                                            height: '32px'
                                                        }}
                                                        placeholder={field.placeholder}
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor = '#667eea';
                                                            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor = '#e5e7eb';
                                                            e.target.style.boxShadow = 'none';
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Section 3: Contact & Tax Information */}
                                    <div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                                            {[
                                                { label: 'Contact Number 1', value: ContactNumber1, setter: setContactNumber1, placeholder: '+91 XXXXX XXXXX' },
                                                { label: 'Contact Number 2', value: ContactNumber2, setter: setContactNumber2, placeholder: '+91 XXXXX XXXXX' },
                                                { label: 'Location', value: Location, setter: setLocation, placeholder: 'Location' },
                                                { label: 'Postal Code', value: PostalCode, setter: setPostalCode, placeholder: 'Postal Code' }
                                            ].map((field, index) => (
                                                <div key={index}>
                                                    <label style={{
                                                        display: 'block',
                                                        color: '#374151',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        marginBottom: '6px'
                                                    }}>{field.label}</label>
                                                    <input
                                                        type="text"
                                                        value={field.value}
                                                        onChange={(e) => field.setter(e.target.value)}
                                                        style={{
                                                            width: '100%',
                                                            padding: '9px 12px',
                                                            border: '2px solid #e5e7eb',
                                                            borderRadius: '10px',
                                                            fontSize: '13px',
                                                            transition: 'all 0.2s ease',
                                                            outline: 'none',
                                                            height: '32px'
                                                        }}
                                                        placeholder={field.placeholder}
                                                        onFocus={(e) => {
                                                            e.target.style.borderColor = '#667eea';
                                                            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                        }}
                                                        onBlur={(e) => {
                                                            e.target.style.borderColor = '#e5e7eb';
                                                            e.target.style.boxShadow = 'none';
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div style={{
                                        background: 'linear-gradient(to right, #f9fafb, #f3f4f6)',
                                        padding: '6px 12px',
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        gap: '6px',
                                        height: '25px',
                                        borderTop: '1px solid #e5e7eb'
                                    }}>
                                        <button
                                            onClick={toggleModalGroup}
                                            disabled={isLoading}
                                            style={{
                                                padding: '8px 24px',
                                                background: 'white',
                                                border: '2px solid #e5e7eb',
                                                borderRadius: '10px',
                                                fontSize: '13px',
                                                height: '29px',
                                                fontWeight: '600',
                                                color: '#6b7280',
                                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                                transition: 'all 0.2s ease',
                                                opacity: isLoading ? 0.5 : 1
                                            }}
                                            onMouseEnter={(e) => !isLoading && (e.target.style.background = '#f9fafb')}
                                            onMouseLeave={(e) => !isLoading && (e.target.style.background = 'white')}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={addGroupRecord}
                                            disabled={isLoading}
                                            style={{
                                                padding: '6px 12px',
                                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                //background: 'linear-gradient(135deg, #041815ff 0%, #045157ff 100%)',
                                                border: 'none',
                                                borderRadius: '10px',
                                                fontSize: '13px',
                                                height: '29px',
                                                fontWeight: '600',
                                                color: 'white',
                                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                                transition: 'all 0.2s ease',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                                                opacity: isLoading ? 0.7 : 1
                                            }}
                                            onMouseEnter={(e) => !isLoading && (e.target.style.transform = 'translateY(-2px)')}
                                            onMouseLeave={(e) => !isLoading && (e.target.style.transform = 'translateY(0)')}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <CircularProgress size={18} color="inherit" />
                                                    <span>Saving...</span>
                                                </>
                                            ) : (
                                                <>
                                                    <span>✓</span>
                                                    <span>Add Patient</span>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            )
            }

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', width: '100%', marginTop: '-10px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#134B70', padding: '2px' }}>

                            <TableRow>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                        borderBottom: '2px solid #1e40af',
                                    }}>
                                    Sl.No
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                        borderBottom: '2px solid #1e40af',
                                    }}>
                                    MRD-No
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                        borderBottom: '2px solid #1e40af',
                                    }}>
                                    Name
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                        borderBottom: '2px solid #1e40af',
                                    }}>
                                    Contact No 1
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                        borderBottom: '2px solid #1e40af',
                                    }}>
                                    Location
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                        borderBottom: '2px solid #1e40af',
                                    }}>
                                    Postal Code
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                        borderBottom: '2px solid #1e40af',
                                    }}>
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    sx={{
                                        '&:hover': { backgroundColor: '#F1E7E7' },
                                        transition: 'background-color 0.3s ease-in-out',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <TableCell sx={{ padding: '2px', borderRight: '1px solid # #f4dfdfff', fontSize: '11.5px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ padding: '2px', borderRight: '1px solid # #f4dfdfff', fontSize: '11.5px' }}>{item.MRDNo}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px', width: '30%', fontSize: '11.5px' }}>{item.Name}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.ContactNumber1}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.Location}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.PostalCode}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'right', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>
                                        {/* {hasEditMasterPermission && ( */}
                                        <Tooltip
                                            title="Appointment History" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#059669',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton onClick={(e) => {
                                                e.stopPropagation();
                                                openAppointmentListModal(item.Id, item.Name, item.MRDNo);
                                            }}>
                                                <ListAltIcon style={{ color: '#059669', fontSize: '17px' }} />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip
                                            title="Create Appointment" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#1e40af',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton onClick={() => openAppointmentModal(item.Id)}>
                                                <EventIcon style={{ color: '#1e40af', fontSize: '17px' }} />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip
                                            title="Patient Edit" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#110441ff',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton onClick={() => openDetailModal(item.Id)}>
                                                <EditIcon style={{ color: '#110441ff', fontSize: '17px' }} />
                                            </IconButton>
                                        </Tooltip>
                                        {/* )}
                                        {hasDeleteMasterPermission && ( */}
                                        <Tooltip
                                            title="Patient Delete" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#DA6C6C',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}>
                                                {item.IsActive ? <DeleteIcon style={{ color: 'brown', fontSize: '17px' }} /> : <ActivateIcon />}
                                            </IconButton>
                                        </Tooltip>
                                        {/* )} */}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                                    Cancel
                                </button>
                                <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>

                    </Table>
                </TableContainer>

                {isDetailModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                        <div
                            className="bg-white w-full overflow-hidden"
                            style={{
                                maxWidth: '900px',
                                maxHeight: '70vh',
                                borderRadius: '16px',
                                boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                                animation: 'zoomIn 0.3s ease-out'
                            }}
                        >
                            {/* Modal Header */}
                            <div style={{
                                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                padding: '16px 24px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                                height: '55px',
                            }}>
                                <div style={{ height: '20px' }}>
                                    <h6 style={{
                                        color: 'white',
                                        fontSize: '15px',
                                        fontWeight: '700',
                                        margin: 0,
                                        letterSpacing: '-0.3px',
                                        marginTop: '-10px',
                                    }}>
                                        Edit Patient
                                    </h6>
                                    <p style={{
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        fontSize: '13px',
                                        margin: '2px 0 0 0'
                                    }}>
                                        Update Patient information
                                    </p>
                                </div>
                                <button
                                    onClick={toggleModalGrp2}
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.2)',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '36px',
                                        height: '36px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        color: 'white',
                                        fontSize: '22px',
                                        fontWeight: '300'
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                                    onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                                >
                                    ×
                                </button>
                            </div>

                            {/* Modal Body */}
                            <div className="overflow-y-auto" style={{ maxHeight: 'calc(75vh - 150px)', padding: '16px 20px' }}>
                                {errorMessageEdit && (
                                    <div style={{
                                        background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
                                        border: '1px solid #fca5a5',
                                        borderRadius: '12px',
                                        padding: '16px',
                                        marginBottom: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px'
                                    }}>
                                        <span style={{ fontSize: '20px' }}>⚠️</span>
                                        <p style={{ color: '#991b1b', fontSize: '14px', margin: 0, fontWeight: '500' }}>{errorMessageEdit}</p>
                                    </div>
                                )}

                                <form onSubmit={updateRecord}>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                        {/* Section 1: Basic Information */}
                                        {/* <h3 style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#374151',
                                            marginBottom: '12px',
                                            paddingBottom: '6px',
                                            borderBottom: '2px solid #e5e7eb'
                                        }}>
                                            Basic Information
                                        </h3> */}
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                            <div className="md:col-span-2">
                                                <label style={{
                                                    display: 'block',
                                                    color: '#374151',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    marginBottom: '6px'
                                                }}>
                                                    Name <span style={{ color: '#ef4444' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="Name"
                                                    value={updatedData.Name || ''}
                                                    onChange={handleUpdateInputChange}
                                                    style={{
                                                        width: '100%',
                                                        padding: '7px 10px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '32px'
                                                    }}
                                                    placeholder="Enter customer name"
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>
                                            <div className="md:col-span-1">
                                                <label style={{
                                                    display: 'block',
                                                    color: '#374151',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    marginBottom: '6px'
                                                }}>
                                                    MRD-No
                                                </label>
                                                <input
                                                    type="text"
                                                    name="Name"
                                                    value={updatedData.MRDNo || ''}
                                                    onChange={handleUpdateInputChange}
                                                    style={{
                                                        width: '100%',
                                                        padding: '7px 10px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        fontSize: '13px',
                                                        transition: 'all 0.2s ease',
                                                        outline: 'none',
                                                        height: '32px'
                                                    }}
                                                    readOnly
                                                    placeholder="Enter customer name"
                                                    onFocus={(e) => {
                                                        e.target.style.borderColor = '#667eea';
                                                        e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.borderColor = '#e5e7eb';
                                                        e.target.style.boxShadow = 'none';
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Section 2: Address Information */}
                                        <div>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                                {[
                                                    { label: 'Address Line 1', name: 'AddressLine1', placeholder: 'Street address' },
                                                    { label: 'Address Line 2', name: 'AddressLine2', placeholder: 'Apartment, suite, etc.' }
                                                ].map((field, index) => (
                                                    <div key={index}>
                                                        <label style={{
                                                            display: 'block',
                                                            color: '#374151',
                                                            fontSize: '12px',
                                                            fontWeight: '600',
                                                            marginBottom: '6px'
                                                        }}>{field.label}</label>
                                                        <input
                                                            type="text"
                                                            name={field.name}
                                                            value={updatedData[field.name] || ''}
                                                            onChange={handleUpdateInputChange}
                                                            style={{
                                                                width: '100%',
                                                                padding: '9px 12px',
                                                                border: '2px solid #e5e7eb',
                                                                borderRadius: '10px',
                                                                fontSize: '13px',
                                                                transition: 'all 0.2s ease',
                                                                outline: 'none',
                                                                height: '32px'
                                                            }}
                                                            placeholder={field.placeholder}
                                                            onFocus={(e) => {
                                                                e.target.style.borderColor = '#f59e0b';
                                                                e.target.style.boxShadow = '0 0 0 2px rgba(245, 158, 11, 0.1)';
                                                            }}
                                                            onBlur={(e) => {
                                                                e.target.style.borderColor = '#e5e7eb';
                                                                e.target.style.boxShadow = 'none';
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Section 3: Contact & Tax Information */}
                                        <div>
                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                                                {[
                                                    { label: 'Contact Number 1', name: 'ContactNumber1', placeholder: '+91 XXXXX XXXXX' },
                                                    { label: 'Contact Number 2', name: 'ContactNumber2', placeholder: '+91 XXXXX XXXXX' },
                                                    { label: 'Location', name: 'Location', placeholder: 'Location' },
                                                    { label: 'Postal Code', name: 'PostalCode', placeholder: 'Postal Code' }
                                                ].map((field, index) => (
                                                    <div key={index}>
                                                        <label style={{
                                                            display: 'block',
                                                            color: '#374151',
                                                            fontSize: '12px',
                                                            fontWeight: '600',
                                                            marginBottom: '6px'
                                                        }}>{field.label}</label>
                                                        <input
                                                            type="text"
                                                            name={field.name}
                                                            value={updatedData[field.name] || ''}
                                                            onChange={handleUpdateInputChange}
                                                            style={{
                                                                width: '100%',
                                                                padding: '9px 12px',
                                                                border: '2px solid #e5e7eb',
                                                                borderRadius: '10px',
                                                                fontSize: '13px',
                                                                transition: 'all 0.2s ease',
                                                                outline: 'none',
                                                                height: '32px'
                                                            }}
                                                            placeholder={field.placeholder}
                                                            onFocus={(e) => {
                                                                e.target.style.borderColor = '#f59e0b';
                                                                e.target.style.boxShadow = '0 0 0 2px rgba(245, 158, 11, 0.1)';
                                                            }}
                                                            onBlur={(e) => {
                                                                e.target.style.borderColor = '#e5e7eb';
                                                                e.target.style.boxShadow = 'none';
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div style={{
                                            background: 'linear-gradient(to right, #f9fafb, #f3f4f6)',
                                            padding: '6px 12px',
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            gap: '6px',
                                            height: '25px',
                                            borderTop: '1px solid #e5e7eb'
                                        }}>
                                            <button
                                                onClick={toggleModalGrp2}
                                                disabled={isUpdateLoading}
                                                style={{
                                                    padding: '6px 12px',
                                                    background: 'white',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '10px',
                                                    height: '29px',
                                                    fontSize: '13px',
                                                    fontWeight: '600',
                                                    color: '#6b7280',
                                                    cursor: isUpdateLoading ? 'not-allowed' : 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    opacity: isUpdateLoading ? 0.5 : 1
                                                }}
                                                onMouseEnter={(e) => !isUpdateLoading && (e.target.style.background = '#f9fafb')}
                                                onMouseLeave={(e) => !isUpdateLoading && (e.target.style.background = 'white')}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                onClick={updateRecord}
                                                disabled={isUpdateLoading}
                                                style={{
                                                    padding: '6px 12px',
                                                    background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                                    border: 'none',
                                                    borderRadius: '10px',
                                                    height: '29px',
                                                    fontSize: '13px',
                                                    fontWeight: '600',
                                                    color: 'white',
                                                    cursor: isUpdateLoading ? 'not-allowed' : 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)',
                                                    opacity: isUpdateLoading ? 0.7 : 1
                                                }}
                                                onMouseEnter={(e) => !isUpdateLoading && (e.target.style.transform = 'translateY(-2px)')}
                                                onMouseLeave={(e) => !isUpdateLoading && (e.target.style.transform = 'translateY(0)')}
                                            >
                                                {isUpdateLoading ? (
                                                    <>
                                                        <CircularProgress size={18} color="inherit" />
                                                        <span>Updating...</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span>✓</span>
                                                        <span>Update Patient</span>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                )
                }

                {/* Appointment Modal */}
                {isAppointmentModalOpen && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        backdropFilter: 'blur(4px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        padding: '20px',
                    }}>
                        <div style={{
                            background: 'white',
                            borderRadius: '12px',
                            width: '100%',
                            maxWidth: '900px',
                            maxHeight: '85vh',
                            overflow: 'hidden',
                            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',

                        }}>
                            {/* Modal Header */}
                            <div style={{
                                background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
                                padding: '16px 20px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                borderBottom: '2px solid #1e40af',
                                height: '45px'
                            }}>
                                <div>
                                    <p style={{
                                        color: 'rgba(255,255,255,0.9)',
                                        fontSize: '14px',
                                        margin: '2px 0 0 0'
                                    }}>
                                        Schedule a new patient appointment
                                    </p>
                                </div>
                                <button
                                    onClick={() => setIsAppointmentModalOpen(false)}
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.2)',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '36px',
                                        height: '36px',
                                        cursor: 'pointer',
                                        color: 'white',
                                        fontSize: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                                    onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                                >
                                    ×
                                </button>
                            </div>

                            {/* Modal Body */}
                            <div style={{ padding: '20px', maxHeight: 'calc(85vh - 150px)', overflowY: 'auto' }}>
                                <form onSubmit={handleAppointmentSubmit}>
                                    {/* Form Grid - Row 1 */}
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr 1fr 1fr',
                                        gap: '16px',
                                        marginBottom: '16px'
                                    }}>
                                        {/* Doctor */}
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '6px',
                                                fontSize: '11px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                textTransform: 'uppercase'
                                            }}>
                                                Doctor <span style={{ color: '#dc2626' }}>*</span>
                                            </label>
                                            <select
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '11px',
                                                    outline: 'none',
                                                    backgroundColor: 'white',
                                                    height: '32px'
                                                }}
                                                value={appointmentFormData.doctorId || ''}
                                                onChange={(e) => handleAppointmentChange("doctorId", e.target.value)}
                                            >
                                                <option value="">Select Doctor</option>
                                                {doctors.map((doctor) => (
                                                    <option key={doctor.Id} value={doctor.Id}>
                                                        {doctor.Name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Patient Name */}
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '6px',
                                                fontSize: '11px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                textTransform: 'uppercase'
                                            }}>
                                                Patient Name
                                            </label>
                                            <input
                                                type="text"
                                                readOnly
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    backgroundColor: '#f9fafb',
                                                    height: '32px'
                                                }}
                                                value={appointmentFormData.patientName || ''}
                                            />
                                        </div>

                                        {/* MRD No */}
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '6px',
                                                fontSize: '11px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                textTransform: 'uppercase'
                                            }}>
                                                MRD No
                                            </label>
                                            <input
                                                type="text"
                                                readOnly
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    backgroundColor: '#f9fafb',
                                                    height: '32px'
                                                }}
                                                value={appointmentFormData.patientMRD || ''}
                                            />
                                        </div>

                                        {/* Phone No */}
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '6px',
                                                fontSize: '11px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                textTransform: 'uppercase'
                                            }}>
                                                Phone No
                                            </label>
                                            <input
                                                type="text"
                                                readOnly
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    backgroundColor: '#f9fafb',
                                                    height: '32px'
                                                }}
                                                value={appointmentFormData.patientPhone || ''}
                                            />
                                        </div>
                                    </div>

                                    {/* Form Grid - Row 2 */}
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr 100px 1.5fr',
                                        gap: '16px',
                                        marginBottom: '16px'
                                    }}>
                                        {/* Appointment Date */}
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '6px',
                                                fontSize: '11px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                textTransform: 'uppercase'
                                            }}>
                                                Appointment Date <span style={{ color: '#dc2626' }}>*</span>
                                            </label>
                                            <input
                                                type="date"
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    outline: 'none',
                                                    height: '32px'
                                                }}
                                                value={appointmentFormData.appointmentDate || ''}
                                                onChange={(e) => handleAppointmentChange("appointmentDate", e.target.value)}
                                            />
                                        </div>

                                        {/* Appointment Time */}
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '6px',
                                                fontSize: '11px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                textTransform: 'uppercase'
                                            }}>
                                                Appointment Time <span style={{ color: '#dc2626' }}>*</span>
                                            </label>
                                            <input
                                                type="time"
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 12px',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    outline: 'none',
                                                    height: '32px'
                                                }}
                                                value={appointmentFormData.appointmentTime || ''}
                                                onChange={(e) => handleAppointmentChange("appointmentTime", e.target.value)}
                                            />
                                        </div>

                                        {/* Amount */}
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '6px',
                                                fontSize: '11px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                textTransform: 'uppercase'
                                            }}>
                                                Amount <span style={{ color: '#dc2626' }}>*</span>
                                            </label>
                                            <input
                                                type="number"
                                                style={{
                                                    width: '100%',
                                                    padding: '8px 10px',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    fontSize: '13px',
                                                    outline: 'none',
                                                    textAlign: 'right',
                                                    height: '32px'
                                                }}
                                                value={appointmentFormData.consultationamount || ''}
                                                onChange={(e) => handleAppointmentChange("amount", e.target.value)}
                                            />
                                        </div>

                                        {/* Payment Modes */}
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                marginBottom: '6px',
                                                fontSize: '11px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                textTransform: 'uppercase'
                                            }}>
                                                Payment Modes <span style={{ color: '#dc2626' }}>*</span>
                                            </label>
                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                <select
                                                    style={{
                                                        width: '100px',
                                                        padding: '4px 8px',
                                                        border: '2px solid #e5e7eb',
                                                        borderRadius: '8px',
                                                        fontSize: '11px',
                                                        outline: 'none',
                                                        backgroundColor: 'white',
                                                        height: '32px'
                                                    }}
                                                    value={appointmentFormData.paymentModeId || ''}
                                                    onChange={(e) => handleAppointmentChange("paymentModeId", e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    {paymentModes.map((Modes) => (
                                                        <option key={Modes.Id} value={Modes.Id}>
                                                            {Modes.Name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {/* Payment Received Checkbox */}
                                                <label style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '4px',
                                                    cursor: 'pointer',
                                                    fontSize: '10px',
                                                    fontWeight: '600',
                                                    color: '#374151',
                                                    textTransform: 'uppercase',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={appointmentFormData.IsPaymentCollected || false}
                                                        onChange={(e) => handleAppointmentChange("IsPaymentCollected", e.target.checked)}
                                                        style={{
                                                            width: '16px',
                                                            height: '16px',
                                                            cursor: 'pointer',
                                                            accentColor: '#1e40af'
                                                        }}
                                                    />
                                                    Payment Received
                                                </label>
                                            </div>
                                        </div>

                                    </div>

                                    {/* Remark */}
                                    <div style={{ marginBottom: '16px' }}>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '6px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#374151',
                                            textTransform: 'uppercase'
                                        }}>
                                            Remark
                                        </label>
                                        <textarea
                                            style={{
                                                width: '100%',
                                                padding: '8px 12px',
                                                border: '2px solid #e5e7eb',
                                                borderRadius: '8px',
                                                fontSize: '13px',
                                                minHeight: '25px',
                                                resize: 'vertical',
                                                outline: 'none'
                                            }}
                                            rows={1}
                                            value={appointmentFormData.remark || ''}
                                            onChange={(e) => handleAppointmentChange("remark", e.target.value)}
                                        ></textarea>
                                    </div>

                                    {/* Checkboxes */}


                                    {/* Submit Buttons */}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        gap: '12px'
                                    }}>
                                        <button
                                            type="button"
                                            onClick={() => setIsAppointmentModalOpen(false)}
                                            disabled={isAppointmentLoading}
                                            style={{
                                                padding: '10px 24px',
                                                background: 'white',
                                                border: '2px solid #e5e7eb',
                                                borderRadius: '8px',
                                                height: '29px',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: '#6b7280',
                                                cursor: isAppointmentLoading ? 'not-allowed' : 'pointer',
                                                opacity: isAppointmentLoading ? 0.5 : 1,
                                            }}
                                        >
                                            <span style={{}}>Cancel</span>
                                        </button>
                                        <button
                                            type="submit"
                                            disabled={isAppointmentLoading}
                                            style={{
                                                padding: '10px 24px',
                                                background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)',
                                                border: 'none',
                                                borderRadius: '8px',
                                                height: '29px',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                color: 'white',
                                                cursor: isAppointmentLoading ? 'not-allowed' : 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                opacity: isAppointmentLoading ? 0.7 : 1
                                            }}
                                        >
                                            {isAppointmentLoading ? (
                                                <>
                                                    <CircularProgress size={18} color="inherit" />
                                                    <span>Saving...</span>
                                                </>
                                            ) : (
                                                <>
                                                    <span>💾</span>
                                                    <span>Save Appointment</span>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}

                <div style={{
                    position: 'fixed',
                    bottom: '12px',
                    right: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.3rem',
                    padding: '0.3rem 0.65rem',
                    background: 'rgba(255, 255, 255, 0.9)',
                    borderRadius: '14px',
                    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.06)',
                    fontFamily: 'serif',
                    fontWeight: 'bold',
                    color: '#2c3e50',
                    fontSize: '0.7rem',
                    backdropFilter: 'blur(10px)'
                }}>
                    <CopyrightIcon />
                    <b>EFFTABS SOLUTIONS LLP</b>
                </div>
            </div >

            {/* Appointment List Modal */}
            {isModalGrpOpenAppointment && (
                <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                    <div
                        className="bg-white w-full overflow-hidden"
                        style={{
                            maxWidth: '1200px',
                            maxHeight: '85vh',
                            borderRadius: '16px',
                            boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                            animation: 'zoomIn 0.3s ease-out'
                        }}
                    >
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                            padding: '16px 24px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                            height: '55px',
                        }}>
                            <div>
                                <h6 style={{
                                    color: 'white',
                                    //fontSize: '16px',
                                    fontWeight: '700',
                                    margin: 0,
                                    letterSpacing: '-0.3px',
                                }}>
                                    📋 {selectedPatientForList ? 'Patient Appointment History' : 'All Appointments'}
                                </h6>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    fontSize: '13px',
                                    margin: '4px 0 0 0'
                                }}>
                                    {selectedPatientForList
                                        ? `${selectedPatientForList.name} - MRD: ${selectedPatientForList.mrd}`
                                        : 'Showing all patient appointments'}
                                </p>
                            </div>
                            <button
                                onClick={toggleModalGroupAppointments}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.2)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '36px',
                                    height: '36px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    color: 'white',
                                    fontSize: '22px',
                                    fontWeight: '300'
                                }}
                                onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                                onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                            >
                                ×
                            </button>
                        </div>

                        {/* Filter Bar */}
                        <div style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb', background: '#f9fafb', display: 'flex', gap: '12px', alignItems: 'center' }}>
                            {/* Date Filter */}
                            <div style={{ flex: 1 }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#374151', marginBottom: '4px', textTransform: 'uppercase' }}>
                                    📅 Filter by Date
                                </label>
                                <input
                                    type="date"
                                    value={appointmentDateFilter}
                                    onChange={(e) => setAppointmentDateFilter(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '8px 12px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '13px',
                                        outline: 'none',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#059669'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                />
                            </div>

                            {/* Doctor Filter */}
                            <div style={{ flex: 1 }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#374151', marginBottom: '4px', textTransform: 'uppercase' }}>
                                    👨‍⚕️ Filter by Doctor
                                </label>
                                <select
                                    value={appointmentDoctorFilter}
                                    onChange={(e) => setAppointmentDoctorFilter(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '8px 12px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '13px',
                                        outline: 'none',
                                        backgroundColor: 'white',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#059669'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                >
                                    <option value="">All Doctors</option>
                                    {[...new Set(appointmentsList.map(apt => apt.DoctorName).filter(Boolean))].sort().map((doctorName, index) => (
                                        <option key={index} value={doctorName}>{doctorName}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Clear Filters Button */}
                            {(appointmentDateFilter || appointmentDoctorFilter) && (
                                <button
                                    onClick={() => {
                                        setAppointmentDateFilter('');
                                        setAppointmentDoctorFilter('');
                                    }}
                                    style={{
                                        padding: '8px 16px',
                                        background: '#ef4444',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        marginTop: '20px',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = '#dc2626'}
                                    onMouseLeave={(e) => e.target.style.background = '#ef4444'}
                                >
                                    ✕ Clear
                                </button>
                            )}
                        </div>

                        {/* Modal Body */}
                        <div className="overflow-y-auto" style={{ maxHeight: 'calc(85vh - 160px)', padding: '0' }}>
                            {isLoadingAppointments ? (
                                <div style={{ padding: '40px', textAlign: 'center' }}>
                                    <CircularProgress size={40} style={{ color: '#059669' }} />
                                    <p style={{ marginTop: '16px', color: '#6b7280' }}>Loading appointments...</p>
                                </div>
                            ) : getFilteredAppointments().length === 0 ? (
                                <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>
                                    <p style={{ fontSize: '16px', fontWeight: '500' }}>
                                        {(appointmentDateFilter || appointmentDoctorFilter) ? 'No appointments match your filters' : 'No appointments found'}
                                    </p>
                                </div>
                            ) : (
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                        <tr>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #059669 0%, #047857 100%)',
                                                color: 'white',
                                                padding: '5px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'center',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                #
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #059669 0%, #047857 100%)',
                                                color: 'white',
                                                padding: '5px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Date
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #059669 0%, #047857 100%)',
                                                color: 'white',
                                                padding: '5px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Time
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #059669 0%, #047857 100%)',
                                                color: 'white',
                                                padding: '5px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Patient Name
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #059669 0%, #047857 100%)',
                                                color: 'white',
                                                padding: '5px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Doctor
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #059669 0%, #047857 100%)',
                                                color: 'white',
                                                padding: '5px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'right',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Amount
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #059669 0%, #047857 100%)',
                                                color: 'white',
                                                padding: '5px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'center',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Status
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #059669 0%, #047857 100%)',
                                                color: 'white',
                                                padding: '5px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px'
                                            }}>
                                                Remark
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getFilteredAppointments().map((appointment, index) => (
                                            <tr
                                                key={appointment.Id}
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? 'white' : '#f9fafb',
                                                    transition: 'background-color 0.15s ease'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0fdf4'}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? 'white' : '#f9fafb'}
                                            >
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#059669',
                                                    fontWeight: '600',
                                                    textAlign: 'center',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {index + 1}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#1f2937',
                                                    fontWeight: '500',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {formatDate(appointment.AppointmentDate)}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#1f2937',
                                                    fontWeight: '500',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {appointment.AppointmentTime || 'N/A'}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#1f2937',
                                                    fontWeight: '600',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {appointment.PatientName || 'N/A'}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#1f2937',
                                                    fontWeight: '600',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {appointment.DoctorName || 'N/A'}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#1f2937',
                                                    fontWeight: '600',
                                                    textAlign: 'right',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {appointment.Amount || '0'}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '11px',
                                                    textAlign: 'center',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {appointment.IsCompleted ? (
                                                        <span style={{
                                                            background: '#d1fae5',
                                                            color: '#065f46',
                                                            padding: '4px 12px',
                                                            borderRadius: '12px',
                                                            fontWeight: '600'
                                                        }}>
                                                            ✓ Completed
                                                        </span>
                                                    ) : appointment.IsRescheduled ? (
                                                        <span style={{
                                                            background: '#fef3c7',
                                                            color: '#92400e',
                                                            padding: '4px 12px',
                                                            borderRadius: '12px',
                                                            fontWeight: '600'
                                                        }}>
                                                            ↻ Rescheduled
                                                        </span>
                                                    ) : (
                                                        <span style={{
                                                            background: '#dbeafe',
                                                            color: '#1e40af',
                                                            padding: '4px 12px',
                                                            borderRadius: '12px',
                                                            fontWeight: '600'
                                                        }}>
                                                            ⏳ Pending
                                                        </span>
                                                    )}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#6b7280',
                                                    fontWeight: '400',
                                                    borderBottom: '1px solid #e5e7eb'
                                                }}>
                                                    {appointment.Remark || '-'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Patient History Modal - Single Patient (No Filters) */}
            {isPatientHistoryModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                    <div
                        className="bg-white w-full overflow-hidden"
                        style={{
                            maxWidth: '1000px',
                            maxHeight: '85vh',
                            borderRadius: '16px',
                            boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                            animation: 'zoomIn 0.3s ease-out'
                        }}
                    >
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            padding: '16px 24px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '2px solid #764ba2',
                            height: '65px',
                        }}>
                            <div>
                                <h6 style={{
                                    color: 'white',
                                    fontSize: '16px',
                                    fontWeight: '700',
                                    margin: 0,
                                    letterSpacing: '-0.3px',
                                }}>
                                    📋 Patient Appointment History
                                </h6>
                                <p style={{
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    fontSize: '13px',
                                    margin: '4px 0 0 0'
                                }}>
                                    {selectedPatientForList?.name} - MRD: {selectedPatientForList?.mrd}
                                </p>
                            </div>
                            <button
                                onClick={() => setIsPatientHistoryModalOpen(false)}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.2)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '36px',
                                    height: '36px',
                                    cursor: 'pointer',
                                    color: 'white',
                                    fontSize: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                                onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                            >
                                ×
                            </button>
                        </div>

                        {/* Modal Body - No Filters */}
                        <div className="overflow-y-auto" style={{ maxHeight: 'calc(85vh - 100px)', padding: '0' }}>
                            {isLoadingPatientHistory ? (
                                <div style={{ padding: '40px', textAlign: 'center' }}>
                                    <CircularProgress size={40} style={{ color: '#667eea' }} />
                                    <p style={{ marginTop: '16px', color: '#6b7280' }}>Loading appointments...</p>
                                </div>
                            ) : patientHistoryList.length === 0 ? (
                                <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>
                                    <p style={{ fontSize: '16px', fontWeight: '500' }}>No appointments found for this patient</p>
                                </div>
                            ) : (
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                        <tr>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
                                                color: 'white',
                                                padding: '10px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'center',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                #
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
                                                color: 'white',
                                                padding: '10px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Date
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
                                                color: 'white',
                                                padding: '10px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Time
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
                                                color: 'white',
                                                padding: '10px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Doctor
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
                                                color: 'white',
                                                padding: '10px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'right',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Amount
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
                                                color: 'white',
                                                padding: '10px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'center',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                borderRight: '1px solid rgba(255,255,255,0.1)'
                                            }}>
                                                Status
                                            </th>
                                            <th style={{
                                                background: 'linear-gradient(180deg, #667eea 0%, #764ba2 100%)',
                                                color: 'white',
                                                padding: '10px',
                                                fontSize: '11px',
                                                fontWeight: '700',
                                                textAlign: 'left',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px'
                                            }}>
                                                Remark
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {patientHistoryList.map((appointment, index) => (
                                            <tr
                                                key={appointment.Id}
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? 'white' : '#f9fafb',
                                                    transition: 'background-color 0.15s ease'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? 'white' : '#f9fafb'}
                                            >
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#667eea',
                                                    fontWeight: '600',
                                                    textAlign: 'center',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {index + 1}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#1f2937',
                                                    fontWeight: '500',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {formatDate(appointment.AppointmentDate)}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#1f2937',
                                                    fontWeight: '500',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {appointment.AppointmentTime || 'N/A'}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#1f2937',
                                                    fontWeight: '600',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {appointment.DoctorName || 'N/A'}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#1f2937',
                                                    fontWeight: '600',
                                                    textAlign: 'right',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {appointment.Amount || '0'}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '11px',
                                                    textAlign: 'center',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    borderRight: '1px solid #e5e7eb'
                                                }}>
                                                    {appointment.IsCompleted ? (
                                                        <span style={{
                                                            background: '#d1fae5',
                                                            color: '#065f46',
                                                            padding: '4px 12px',
                                                            borderRadius: '12px',
                                                            fontWeight: '600'
                                                        }}>
                                                            ✓ Completed
                                                        </span>
                                                    ) : appointment.IsRescheduled ? (
                                                        <span style={{
                                                            background: '#fef3c7',
                                                            color: '#92400e',
                                                            padding: '4px 12px',
                                                            borderRadius: '12px',
                                                            fontWeight: '600'
                                                        }}>
                                                            ↻ Rescheduled
                                                        </span>
                                                    ) : (
                                                        <span style={{
                                                            background: '#dbeafe',
                                                            color: '#1e40af',
                                                            padding: '4px 12px',
                                                            borderRadius: '12px',
                                                            fontWeight: '600'
                                                        }}>
                                                            ⏳ Pending
                                                        </span>
                                                    )}
                                                </td>
                                                <td style={{
                                                    padding: '12px',
                                                    fontSize: '12px',
                                                    color: '#6b7280',
                                                    fontWeight: '400',
                                                    borderBottom: '1px solid #e5e7eb'
                                                }}>
                                                    {appointment.Remark || '-'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default withSessionCheck(PatientIndex);
